/* eslint-disable max-lines */
import { all, call, put } from 'redux-saga/effects'

import routes, { Router } from '../../routes'
import i18n from '../../i18n'
import { app } from '../../configuration'
import { actions as appActions } from '../../redux/app/redux'


export default class AboutSagas {

  static* init() {
    return yield call(AboutSagas.setupSeo)
  }

  static* setupSeo() {
    yield put(
      appActions.setSeo({
        title: i18n.t('SEO_about_title'),
        description: i18n.t('SEO_about_description'),
        keywords: i18n.t('SEO_about_keywords'),
        url: `${app.APP_URL}${Router.getRouteUrl(routes.about)}`,
        noindex: false,
      })
    )
  }


  static* loop() {
    yield all([
      //
    ])
  }

}
